import React from "react";
import { Check, X } from "lucide-react";

/**
 * 5-row Other-Schemes vs MAVULA table for the Safety page.
 * Content is factual and matches MAVULA's published terms.
 */
const ROWS = [
  { label: "Deposit",             other: "25–40% (varies)",                     mv: "Modest, set per project" },
  { label: "Repayment terms",     other: "Rises with inflation",                mv: "Disclosed in your project contract" },
  { label: "Title type",          other: "Leasehold / shared ownership common", mv: "Full freehold — in your name" },
  { label: "Buyer checks",        other: "Visa, permit, credit history",        mv: "Citizenship only — no credit checks" },
  { label: "Fees & commissions",  other: "Hidden, layered",                     mv: "Shown upfront — £0 extra" },
];

export default function ComparisonCard() {
  return (
    <section className="py-14 md:py-20 border-b mv-hairline" data-testid="comparison-card">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Side-by-Side</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          Other schemes vs. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>MAVULA.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
          A plain look at the difference. If any competitor offers better terms, ask them to publish the same table.
        </p>

        <div className="mt-8 mv-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-[14px]">
              <thead>
                <tr className="border-b mv-hairline">
                  <th className="p-4 md:p-5 text-left text-[11px] uppercase tracking-[0.2em]" style={{ color: "var(--mv-muted)" }}>Feature</th>
                  <th className="p-4 md:p-5 text-left text-[11px] uppercase tracking-[0.2em] bg-black/[0.03]" style={{ color: "var(--mv-muted)" }}>Other schemes / mortgages</th>
                  <th className="p-4 md:p-5 text-left text-[11px] uppercase tracking-[0.2em]" style={{ background: "linear-gradient(90deg, rgba(212,175,55,0.14), rgba(10,59,40,0.08))", color: "var(--mv-green)" }}>MAVULA Investment</th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r) => (
                  <tr key={r.label} className="border-b mv-hairline last:border-0">
                    <td className="p-4 md:p-5 mv-green-text font-semibold">{r.label}</td>
                    <td className="p-4 md:p-5 bg-black/[0.02]">
                      <div className="flex items-start gap-2"><X size={16} className="mt-0.5 shrink-0" style={{ color: "#B33A3A" }}/><span>{r.other}</span></div>
                    </td>
                    <td className="p-4 md:p-5" style={{ background: "linear-gradient(180deg, rgba(212,175,55,0.06), rgba(10,59,40,0.03))" }}>
                      <div className="flex items-start gap-2 mv-green-text font-semibold">
                        <Check size={16} className="mt-0.5 shrink-0" style={{ color: "#0A7A2C" }}/>
                        <span>{r.mv}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="p-4 text-[11.5px] font-accent italic" style={{ color: "var(--mv-muted)" }}>
            Illustrative — actual figures vary by country and are always shown before signing.
          </div>
        </div>
      </div>
    </section>
  );
}
